import { useSelector } from 'react-redux';

import { getIsPreviewMenuOn } from 'bento-ordering/locations/selectors';

const useIsPreviewMenuOn = (location = null) => {
  const isPreviewMenuOn = useSelector(state =>
    getIsPreviewMenuOn(state, location)
  );

  return isPreviewMenuOn;
};

export default useIsPreviewMenuOn;
